// src/components/mascot/seasonal.js
// ─────────────────────────────────────────────────────────────
// Fenêtre saisonnière basée sur mois/jour, PAS une année codée en dur —
// se réactive automatiquement chaque année sans y retoucher. Gère le
// passage d'une année à l'autre (ex: 1er décembre → 1er janvier).
// ─────────────────────────────────────────────────────────────

export function isInSeasonalWindow(startMonth, startDay, endMonth, endDay, now = new Date()) {
  const y = now.getFullYear();
  const start = new Date(y, startMonth - 1, startDay);
  const end = new Date(y, endMonth - 1, endDay);
  if (start <= end) return now >= start && now < end;
  // La fenêtre traverse le nouvel an (ex: 1 déc → 1 janv) : "start" (déc, Y)
  // tombe APRÈS "end" (janv, Y) dans le calendrier de l'année Y — on est
  // dans la fenêtre soit après start, soit avant end.
  return now >= start || now < end;
}

export const isHalloweenPeriod = (now = new Date()) => isInSeasonalWindow(10, 1, 11, 1, now);
export const isChristmasPeriod = (now = new Date()) => isInSeasonalWindow(12, 1, 1, 1, now);
